// extracted by mini-css-extract-plugin
module.exports = {"wrap":"index_wrap_33twQ","set":"index_set_2QO5T"};